/**
 * Store information about the current user.
 */
import { SET_USER } from "../actionTypes.js";
import { mergeReducer } from "./common/index.js";
export default mergeReducer(SET_USER, null);
//# sourceMappingURL=user.js.map